import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/joy";
import {FullscreenRounded, FullscreenExitRounded} from "@mui-symbols-material/w300";

const FullscreenToggleButton = () => {
    const [isFullscreen, setIsFullscreen] = useState<boolean>(!!document.fullscreenElement);

    useEffect(() => {
        const handleChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener("fullscreenchange", handleChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleChange);
        };
    }, []);

    const handleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    return (
        <IconButton
            variant="soft"
            color="primary"
            onClick={handleFullscreen}
        >
            {isFullscreen ? <FullscreenExitRounded /> : <FullscreenRounded />}
        </IconButton>
    );
};

export default FullscreenToggleButton;
